import { HStack, Text, Box } from '@chakra-ui/react'
import { ChevronRight, Home } from 'lucide-react'

export interface BreadcrumbItem {
  label: string
  onClick?: () => void
}

interface DocumentsBreadcrumbProps {
  items: BreadcrumbItem[]
}

export function DocumentsBreadcrumb({ items }: DocumentsBreadcrumbProps) {
  return (
    <HStack gap={2} fontSize="sm" color="gray.600" flexWrap="wrap">
      {items.map((item, index) => (
        <HStack key={index} gap={2}>
          {index === 0 && <Home size={14} />}
          {item.onClick ? (
            <Text
              cursor="pointer"
              _hover={{ color: 'brand.600', textDecoration: 'underline' }}
              onClick={item.onClick}
              fontWeight={index === items.length - 1 ? 'semibold' : 'normal'}
              color={index === items.length - 1 ? 'gray.800' : 'gray.600'}
            >
              {item.label}
            </Text>
          ) : (
            <Text
              fontWeight={index === items.length - 1 ? 'semibold' : 'normal'}
              color={index === items.length - 1 ? 'gray.800' : 'gray.600'}
            >
              {item.label}
            </Text>
          )}
          {index < items.length - 1 && (
            <Box color="gray.400">
              <ChevronRight size={14} />
            </Box>
          )}
        </HStack>
      ))}
    </HStack>
  )
}
